var map = {
	"./1742017317-niti-aayog-registration.jpg": 10227,
	"./Emblem_of_Andhra_Pradesh.png": 80738,
	"./ISO_9001-2015.svg.png": 96698,
	"./Ministry-of-Social-Justice-and-Empowerment.webp": 31874,
	"./Screenshot_2022-05-21-08-06-55-04_4251af1b5b11394b318ec35cda6368c8-1b3da469.webp": 19513,
	"./images.png": 1161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36164;